<template>
<div>
    <div style="position: relative; height: 3px">
        <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
    </div>
    <!-- ./ reservation chips days -->

    <!-- DATATABLE ROWS  reservation-->
    <v-card tile flat>
        <v-data-iterator :items="items" :pagination.sync="pagination" :total-items="total" :rows-per-page-items="rppi">
            <template slot="item" slot-scope="props">
                <v-row class="ma-1 pa-2 grey lighten-5" no-gutters align="center">
                    <v-col cols="9">
                        <div class="">
                            <div class="regular">{{ props.item.body }}</div>
                            <div class="detail">Creat la: {{ getDate(props.item.created_at) }}</div>
                        </div>
                    </v-col>
                    <v-col cols="3">
                        <div class="d-flex align-center" v-if="props.item.author">
                            <v-avatar size="36" class="mx-1">
                                <img v-if="props.item.author.avatar" :src="props.item.author.avatar">
                                <v-icon size="36" v-else>face</v-icon>
                            </v-avatar>
                            <div class="px-2">
                                <div class="important">{{ props.item.author.name }}</div>
                                <div class="faded">{{ props.item.author.id }}</div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </template>
            <template slot="no-data">
                <v-alert :value="true" class="mx-1" type="info" color="primary">
                    No data available.
                </v-alert>
            </template>
        </v-data-iterator>
    </v-card>
    <!-- ./ DATATABLE ROWS  reservation-->
</div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default() {
                return [];
            }
        },

    },
    data() {
        return {
            // all_comments: 0,
            // table attributes
            loading: null,
            total: 0,
            pagination: null,
            rppi: [5, 25, 50, 100],
        }
    },

    methods: {
        getDate(date) {
            if(!date) return date;
            let value = date * 1000;
            return this.$moment(value)
                .format('YYYY-MM-DD');
        },
    },

}
</script>
